/**
 * Mirrors the backend `VehicleType` (src/constants/common.constants.ts in withpara/para-node).
 * The prototype drops `station_wagon` and `box_truck`; both are real values.
 */
export enum VehicleType {
  Sedan = 'sedan',
  Hatchback = 'hatchback',
  StationWagon = 'station_wagon',
  Suv = 'suv',
  Truck = 'truck',
  Bicycle = 'bicycle',
  EBike = 'e_bike',
  EScooter = 'e_scooter',
  Motorcycle = 'motorcycle',
  Scooter = 'scooter',
  Van = 'van',
  CargoVan = 'cargo_van',
  BoxTruck = 'box_truck',
}

/** Every action the steps table can offer. Visibility rules live in utils/partnerDriver/stepActions. */
export enum StepAction {
  CompleteBackgroundCheck = 'complete_background_check',
  CompleteVehicleInsurance = 'complete_vehicle_insurance',
  CompleteDriverLicense = 'complete_driver_license',
  CompleteLmsTraining = 'complete_lms_training',
  CompleteInsuranceDeclaration = 'complete_insurance_declaration',
  CompleteVehicleRegistration = 'complete_vehicle_registration',
  CompleteDotNumber = 'complete_dot_number',
  CompleteFailed = 'complete_failed',
  UploadDocuments = 'upload_documents',
  Reset = 'reset',
  DeleteDocuments = 'delete_documents',
}

/** The three choices of the complete-DOT-number modal; `NoNumber` skips the step (optional steps only). */
export enum DotNumberOption {
  Dot = 'dot',
  UsDot = 'us_dot',
  NoNumber = 'no_number',
}

/** Mirrors the backend `PartnerDriverDeletionReason` (src/constants/partner-driver.constants.ts). */
export enum PartnerDriverDeletionReason {
  RequestedDataDeletion = 'requested_data_deletion',
  RejectedDeactivatedForFraud = 'rejected_deactivated_for_fraud',
}

export enum StatusTone {
  Neutral = 'neutral',
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Critical = 'critical',
}

export enum PartnerDriversTableFields {
  name = 'name',
  email = 'email',
  phone = 'phone',
  partnerName = 'partnerName',
  isActive = 'isActive',
  reimbursementAmount = 'reimbursementAmount',
  reimbursementPercentage = 'reimbursementPercentage',
  pendingChecks = 'pendingChecks',
  otpCode = 'otpCode',
  collectDataTemplateId = 'collectDataTemplateId',
  id = 'id',
}

export enum StepsTableFields {
  step = 'step',
  status = 'status',
  documents = 'documents',
  details = 'details',
  actions = 'actions',
}
